var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.5C1 3.83696 1.26339 3.20107 1.73223 2.73223C2.20107 2.26339 2.83696 2 3.5 2H12.5C13.163 2 13.7989 2.26339 14.2678 2.73223C14.7366 3.20107 15 3.83696 15 4.5V9.5C15 9.8283 14.9353 10.1534 14.8097 10.4567C14.6841 10.76 14.4999 11.0356 14.2678 11.2678C14.0356 11.4999 13.76 11.6841 13.4567 11.8097C13.1534 11.9353 12.8283 12 12.5 12H8.688L5.625 14.68C5.48327 14.8039 5.30885 14.8844 5.12261 14.9118C4.93636 14.9391 4.74617 14.9123 4.57476 14.8345C4.40336 14.7566 4.25801 14.6311 4.15608 14.4728C4.05415 14.3145 3.99996 14.1303 4 13.942V12H3.5C2.83696 12 2.20107 11.7366 1.73223 11.2678C1.26339 10.7989 1 10.163 1 9.5V4.5ZM3.5 3C3.10218 3 2.72064 3.15804 2.43934 3.43934C2.15804 3.72064 2 4.10218 2 4.5V9.5C2 9.89782 2.15804 10.2794 2.43934 10.5607C2.72064 10.842 3.10218 11 3.5 11H5V13.898L8.312 11H12.5C12.8978 11 13.2794 10.842 13.5607 10.5607C13.842 10.2794 14 9.89782 14 9.5V4.5C14 4.10218 13.842 3.72064 13.5607 3.43934C13.2794 3.15804 12.8978 3 12.5 3H3.5Z",
    fill: "#1B3E61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComentIcon);
export default __webpack_public_path__ + "static/media/coment-icon.a68d8f53ada9ed3a7828dad86ed9091b.svg";
export { ForwardRef as ReactComponent };